import { render, staticRenderFns } from "./LeftMeunFooter.vue?vue&type=template&id=b5a063c0&scoped=true&"
import script from "./LeftMeunFooter.vue?vue&type=script&lang=js&"
export * from "./LeftMeunFooter.vue?vue&type=script&lang=js&"
import style0 from "./LeftMeunFooter.vue?vue&type=style&index=0&id=b5a063c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a063c0",
  null
  
)

export default component.exports